module.exports = __webpack_public_path__ + "static/media/search_icon.3d1ce932.svg";